// app/not-found.tsx
//
// Page 404 globale en FR, prend le relai du "This page could not be found"
// natif de Next.js. Affichée pour toute URL non-routée (côté pages App Router
// uniquement — pas pour les API routes, qui renvoient leur propre JSON 404).

"use client";

import Link from "next/link";
import Image from "next/image";
import { ArrowLeft, Compass } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-neutral-50 px-6 text-center">
      <div className="w-full max-w-md space-y-6">
        <Image
          src="/oneplace-logo.png"
          alt="OnePlace"
          width={140}
          height={40}
          priority
          className="mx-auto h-10 w-auto"
        />

        <div className="space-y-2">
          <div className="text-7xl font-bold tracking-tight text-neutral-900">
            404
          </div>
          <h1 className="text-xl font-semibold text-neutral-900">
            Page introuvable
          </h1>
          <p className="text-sm text-neutral-600">
            Cette page n&apos;existe pas (ou plus). Vérifiez le lien ou retournez
            à votre tableau de bord.
          </p>
        </div>

        <div className="flex flex-col gap-2 sm:flex-row sm:justify-center">
          <Button asChild>
            <Link href="/">
              <Compass className="h-4 w-4" />
              Retour à l&apos;accueil
            </Link>
          </Button>
          <Button
            variant="secondary"
            type="button"
            onClick={() => {
              if (typeof window !== "undefined" && window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <ArrowLeft className="h-4 w-4" />
            Page précédente
          </Button>
        </div>
      </div>
    </div>
  );
}
